import { Link } from "react-router-dom";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Target, Clock, Globe, Play, ChevronRight } from "lucide-react";
import { getScoreColor, getLanguageLabel } from "./ProfileComponents";

export function RecentSessionsCard({ sessions, isOwnProfile }) {
  return (
    <Card className="premium-card fade-up" data-testid="profile-recent-sessions">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-bold text-[#0B1F3B]">Recent Sessions</CardTitle>
          {isOwnProfile && (
            <Link to="/simulator">
              <Button size="sm" className="bg-[#0B1F3B] hover:bg-[#0B1F3B]/90">
                <Play className="w-3.5 h-3.5 mr-1.5" /> New Session
              </Button>
            </Link>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {sessions?.length > 0 ? (
          <div className="space-y-3">
            {sessions.map((session) => (
              <SessionRow key={session.id} session={session} />
            ))}
          </div>
        ) : (
          <div className="text-center py-10">
            <Target className="w-10 h-10 text-slate-200 mx-auto mb-3" />
            <p className="text-slate-400 text-sm">No practice sessions yet</p>
            {isOwnProfile && (
              <Link to="/simulator">
                <Button size="sm" className="mt-4 bg-[#0B1F3B] hover:bg-[#0B1F3B]/90">Start Practicing</Button>
              </Link>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

function SessionRow({ session }) {
  const linkTo = session.status === "evaluated" ? `/evaluation/${session.id}` : "#";
  return (
    <Link to={linkTo} className="block">
      <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl hover:bg-slate-100 transition-colors">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-1">
            <h4 className="text-sm font-semibold text-[#0B1F3B]">{session.scenario_name}</h4>
            <Badge variant="outline" className="text-xs">
              {session.status === "evaluated" ? "Evaluated" : session.status}
            </Badge>
            {session.selected_language && (
              <Badge variant="outline" className="text-xs border-[#2563EB]/20 text-[#2563EB]">
                <Globe className="w-3 h-3 mr-1" />
                {getLanguageLabel(session.selected_language)}
              </Badge>
            )}
          </div>
          {session.started_at && (
            <p className="text-xs text-slate-400 flex items-center gap-1">
              <Clock className="w-3 h-3" />
              {new Date(session.started_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
            </p>
          )}
        </div>
        <div className="flex items-center gap-4">
          {session.readiness_score != null && (
            <div className="text-center">
              <p className={`text-xl font-bold ${getScoreColor(session.readiness_score)}`}>{session.readiness_score}%</p>
              <p className="text-xs text-slate-400">Readiness</p>
            </div>
          )}
          {session.total_score != null && (
            <div className="text-center">
              <p className={`text-xl font-bold ${getScoreColor(session.total_score)}`}>{session.total_score}%</p>
              <p className="text-xs text-slate-400">Score</p>
            </div>
          )}
          {session.status === "evaluated" && <ChevronRight className="w-5 h-5 text-slate-300" />}
        </div>
      </div>
    </Link>
  );
}
